import * as Config from '../../../../config';
import React, { useEffect } from 'react';
import PropTypes from 'prop-types';

import Grid from './Grid';
import Filters from '../../filters/Filters';
import Linkage from '../../common/Linkage';
import Next from '../../pagination/Next';
import Prev from '../../pagination/Prev';
import NextGridPortal from '../../pagination/NextGridPortal';
import PrevGridPortal from '../../pagination/PrevGridPortal';

import useFilters from '../../../../hooks/useFilters';

function GridFull({
  dataHook,
  id, title, perPage, width = Config.GRID_WIDTH, height,
  rowCount, rowWidth, rowHeight, columnCount,
  hasFilters = false, filtersStyle, buttonFilterStyle, filtersConfig = [`chart_name`, `dj_name`, `publish_date`],
  hasPagination = false, allTo = null, allLabel = `View All`, arrowLeftStyle, arrowRightStyle, hasPaginationV2 = false,
  element, loadingElement,
  gutter, style, className
}) {

  rowWidth = rowWidth ?? Config.CARD_WIDTH;
  rowHeight = rowHeight ?? Config.CARD_HEIGHT + Config.GRID_PAD;
  columnCount = columnCount ?? Math.floor(width / (rowWidth + ((gutter && gutter.gap) ? gutter.gap : 0)));
  const columnCountWithoutGap = Math.floor(width / rowWidth);

  if (!rowCount) {
    rowCount = (dataHook && dataHook.items !== null) ? ((dataHook.next) ? Math.floor((dataHook.items.length + perPage) / columnCount) : Math.ceil(dataHook.items.length / columnCount) ) : 0;
    if (rowCount === 0) { rowCount = 1 }
  }
  
  const paginationEnabled = (dataHook) ? dataHook.count > columnCount : false;

  // HOOK Filters - TODO NOT USE BY TRACKS
  const { listFilters, getFiltersFormatted, onValidFilters, onClearFilters, isFirst } = useFilters(filtersConfig);
  useEffect(() => {
    if (dataHook && hasFilters && !isFirst) {
      dataHook.setApiFilters(getFiltersFormatted());
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [listFilters, getFiltersFormatted, hasFilters, isFirst]) // dataHook has te be remove to work correctly

  let loadMore = null;
  if (dataHook && hasPagination && dataHook.pagination.end <= dataHook.pagination.total) {
    loadMore = null;
  } else if (dataHook && !hasPagination && !!dataHook.next) {
    loadMore = dataHook.onLoadMore;
  }

  const itemData = dataHook ? ((dataHook.id === id && dataHook.items !== null) ? dataHook.items : null) : null;
  const bestCardWith = Math.floor(width / columnCountWithoutGap);

  return (
    <div className={`flexColumn ${className}`} style={{ ...style, height : (!hasPagination && rowCount > 1) ? height + Config.LC_PAD_BETWEEN : `auto` }}>
      <div className={`flexRow grid-headers`}>
        { title ? <span className={`bp-h5 type-regular type-light`}>{title}</span> : null }
        { hasPaginationV2 && dataHook && dataHook.items.length > 0 && dataHook.pagination.start !== 0
          ? <PrevGridPortal rootID={`fixedSizeGrid-${id.replace(/\s+/g, "")}`} onClick={dataHook.pagination.prevStack} style={arrowLeftStyle} />
          : null
        }
        { hasPaginationV2 && dataHook && dataHook.items.length > 0 && dataHook.pagination.end < dataHook.pagination.total
          ? <NextGridPortal rootID={`fixedSizeGrid-${id.replace(/\s+/g, "")}`} onClick={dataHook.pagination.nextStack} style={arrowRightStyle} />
          : null
        }
        { hasPagination && dataHook && paginationEnabled ? (
          <div className={`flexRow grid-pagination`}>
            <Prev active={(dataHook.pagination.start !== 0)} onClick={dataHook.pagination.prevStack} style={arrowLeftStyle} />
            <Next active={dataHook.pagination.end < dataHook.pagination.total && !dataHook.loading} onClick={dataHook.pagination.nextStack} style={arrowRightStyle} /> 
            { allLabel !== null ? (dataHook.pagination.start === 0 && dataHook.pagination.end >= dataHook.pagination.total ? null : <Linkage label={allLabel} to={allTo} style={{zIndex: 10}} linkClassName={`pag-all type-medium fz13`} /> ) : null }
          </div>
        ) : null }
      </div>
      { hasFilters && <Filters filters={listFilters} onValid={onValidFilters} height={height} onClear={onClearFilters} style={{ position: `absolute`, top: 0, right: 0, zIndex: 60, ...buttonFilterStyle }} panelStyle={filtersStyle} /> }
      <Grid
        id={id.replace(/\s+/g, "")}
        columnCount={columnCount}
        columnWidth={bestCardWith}
        rowCount={rowCount}
        rowHeight={rowHeight}
        itemData={itemData}
        height={height}
        width={width}
        loadMore={loadMore}
        gutter={gutter}
        element={element}
        loadingElement={loadingElement}
      />
    </div>
  )
}

GridFull.propTypes = {
  dataHook: PropTypes.any,
  width: PropTypes.any,
  height: PropTypes.number.isRequired,
  id: PropTypes.string.isRequired,
  title: PropTypes.string,
  perPage: PropTypes.number,
  hasFilters: PropTypes.bool,
  filtersConfig: PropTypes.array,
  forceHeight: PropTypes.number,
  rowMax: PropTypes.number,
  columnMax: PropTypes.number,
  hasPagination: PropTypes.bool,
  arrowLeftStyle: PropTypes.object,
  arrowRightStyle: PropTypes.object,
  allLabel: PropTypes.string,
  allTo: PropTypes.any,
  style: PropTypes.object,
  gutter: PropTypes.object,
  className: PropTypes.string,

  element: PropTypes.element.isRequired,
  loadingElement: PropTypes.element.isRequired
}

export default GridFull;
